import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
  PERMISSION_TALENTS_WRITE
} from '../../constants'
import { Tooltip } from 'reactstrap';
import UserImage from '../../user-widgets/UserImage'
//import SkillVendorEditPopup from './helpers/SkillVendorEditPopupOrg'
import SkillVendorEditPopup from './helpers/SkillVendorEditPopup'
import ProtectedElement from '../common/helpers/ProtectedElement'
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'
import GoogleMap from '../common/helpers/GoogleMap'
import UnionsAndRepresentationsBox from './profile/helpers/UnionsAndRepresentationsBox'

class SkillVendorOverview extends Component {
  constructor(props) {
    super(props);

    this.doNotUseToggle = this.doNotUseToggle.bind(this);
    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
      modal: false,
      className: 'modal-primary',
      size: 'default'
    };
  }

  doNotUseToggle(e) {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  toggle(e, className, size) {
    e.preventDefault();
    this.setState({
      modal: !this.state.modal,
      className: className,
      size: size
    })
  }

  isActorOrIsSinger(data){
    return data.ProfileTypes.some(element => element.Key === 'VoiceActor') || data.ProfileTypes.some(element => element.Key === 'Singer');
  }

  render() {
    if (this.props.overview === null) {
      return (<div />)
    }
    let overviewData = this.props.overview;

    let userImage = {
      "img": overviewData.AvatarImageUrl.replace('.png', 'x2.png')
    }

    let manageBtn = (
      <ProtectedElement permission={PERMISSION_TALENTS_WRITE}>
        <div className="row">
          <div className="col-6"></div>
          <div className="col-6 text-right">
            <SkillVendorEditPopup skillVendorId={this.props.skillVendorId} />
          </div>
        </div>
      </ProtectedElement>
    )

    return (
      <div>
        {manageBtn}
        <div className="row">
          <div className="col-md-6 widget">
            <div className="title">Personal details</div>
            <div className="row">
              <div className="col-3">
                <div className="user-widget-1">
                  <UserImage user={userImage} />
                </div>
              </div>
              <div className="col-9">
              <div className="row">
                <div className="col-12">
                  <div className="col">
                    <div className="row">
                      <div className="col-5">produb number:</div>
                      <div className="col-7">{overviewData.ProdubNumber}</div>
                    </div>
                    <div className="row">
                      <div className="col-5">Email:</div>
                      <div className="col-7"><a href={'mailto:' + overviewData.Email}>{overviewData.Email}</a></div>
                    </div>
                    <div className="row">
                      <div className="col-5">Phone:</div>
                      <div className="col-7"><a href={'tel:+' + overviewData.PhoneNumberCountryCode + overviewData.PhoneNumber}>+{overviewData.PhoneNumberCountryCode} {overviewData.PhoneNumber}</a></div>
                    </div>
                    {overviewData.SocialMediaProfiles.map((profile, i) => (
                      <div className="row" key={i}>
                        <div className="col-5">{profile.Platform}:</div>
                        <div className="col-7">{profile.Profile}</div>
                      </div>
                       ))}
                      {overviewData.Ethnicity &&
                        <div className="row">
                          <div className="col-5">Ethnicity:</div>
                          <div className="col-7">{overviewData.Ethnicity}</div>
                        </div>
                      }
                      {overviewData.Identity &&
                        <div className="row">
                          <div className="col-5">Identity:</div>
                          <div className="col-7">{overviewData.Identity}</div>
                        </div>
                      }
                      <div className="row">
                        <div className="col-5">Date of birth:</div>
                        <div className="col-7">{overviewData.DateOfBirth}</div>
                      </div>
                      <div className="row">
                        <div className="col-5">Age:</div>
                        <div className="col-7">{overviewData.Age}</div>
                      </div>
                      <div className="row">
                        <div className="col-5">Preferred city:</div>
                        <div className="col-7">{overviewData.PreferredCity}</div>
                      </div>
                      <div className="row">
                        <div className="col-5">Location:</div>
                        <div className="col-7">
                          {overviewData.CountryOfLiving ? overviewData.CountryOfLiving : ''}
                          {overviewData.CountryOfLiving && overviewData.PostalCode || overviewData.CountryOfLiving && overviewData.Region ? ', ':''}
                          {overviewData.Region ? overviewData.Region : '' }
                          {overviewData.CountryOfLiving && overviewData.PostalCode && overviewData.Region|| overviewData.Region && overviewData.PostalCode ? ', ':''}
                          {overviewData.PostalCode ?  overviewData.PostalCode: ''}
                          {overviewData.PostalCode ? <a href="#" onClick={(e, className, size) => this.toggle(e, `modal-primary`, 'default')}><i className="ion-android-pin user-location-icon"></i></a>: ''}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-5">Native language:</div>
                        <div className="col-7">{overviewData.NativeLanguage}</div>
                      </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 widget">
            <div className="title">Access details</div>
            <div className="row">
              <div className="col-4">
                Status:<br />
                Member since:<br />
                Parent name:<br />
                Known talent:<br />
                Do not use (default, applies to new profile):<br />
              </div>
              <div className="col-8">
                {console.log(overviewData)}
                {overviewData.StatusLabel}<br />
                {overviewData.RegistrationDate}<br />
                {overviewData.ParentFullName ? overviewData.ParentFullName : 'Adult'}<br />
                {overviewData.KnownTalent ? 'Yes' : 'No'}<br />
                <span id="DoNotUseReason">
                  {overviewData.DoNotUseReason ? (<span style={{cursor: 'pointer'}}>{overviewData.DoNotUseReason}</span>) : 'No'}
                </span><br />
                {overviewData.DoNotUseReason &&
                  <Tooltip placement="auto" isOpen={this.state.tooltipOpen} target="DoNotUseReason" toggle={this.doNotUseToggle} hideArrow={true} innerClassName="do-not-use-tooltip">
                    {overviewData.DoNotUseComment &&
                      <span>{overviewData.DoNotUseComment}<br /><br /></span>
                    }
                    Date: {overviewData.DoNotUseDate}
                  </Tooltip>
                }
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 widget">
            <div className="title">Additional languages</div>
            <div className="row">
              <div className="col-4">
                {overviewData.AdditionalLanguages.map((language, i) => (
                  <div key={i}>{language}</div>
                ))}
              </div>
            </div>
          </div>
          {this.isActorOrIsSinger(overviewData) ? <UnionsAndRepresentationsBox overviewData={overviewData}/>:'' }
        </div>
        <div className="row">
          <div className="col-md-6 widget">
            <div className="title">Internal notes</div>
            <div className="row">
              <div className="col-12">
                {overviewData.Note}
              </div>
            </div>
          </div>
        </div>
        {manageBtn}
        {this.state.modal ?
          <Modal
            isOpen={this.state.modal}
            toggle={this.toggle}
            wrapClassName={this.state.className}
            size={this.state.size}>
            <ModalHeader toggle={this.toggle}>APPROXIMATE LOCATION</ModalHeader>
            <ModalBody>
              <GoogleMap
                postalCode={overviewData.PostalCode}
                countryOfLiving={overviewData.CountryOfLiving}
              />
            </ModalBody>
            <ModalFooter>
              <button className="btn btn-default btn-rounded" onClick={this.toggle}>
                Close
              </button>
            </ModalFooter>
          </Modal>
        :null}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  overview: state.skillVendorPage.overview
})
const mapDispatchToProps = dispatch => ({
})
export default connect(mapStateToProps, mapDispatchToProps)(SkillVendorOverview)
